import { useEffect, useState } from "react";

// Calcula si el restaurante está abierto usando la hora local de Chihuahua,
// sin importar la zona horaria del visitante.
function getChihuahuaHourFloat() {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chihuahua",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(new Date());
    const hour = parseInt(
      parts.find((p) => p.type === "hour")?.value ?? "0",
      10,
    );
    const minute = parseInt(
      parts.find((p) => p.type === "minute")?.value ?? "0",
      10,
    );
    // Intl puede devolver "24" para medianoche; normalizamos.
    return ((hour % 24) + minute / 60);
  } catch {
    const now = new Date();
    return now.getHours() + now.getMinutes() / 60;
  }
}

export function useOpenStatus(openHour = 11, closeHour = 19) {
  const compute = () => {
    const current = getChihuahuaHourFloat();
    return current >= openHour && current < closeHour;
  };

  const [isOpen, setIsOpen] = useState(compute);

  useEffect(() => {
    const id = setInterval(() => setIsOpen(compute()), 60_000);
    return () => clearInterval(id);
  }, [openHour, closeHour]);

  return isOpen;
}
